import React, { Suspense, useEffect, useState } from 'react';

// Mount on first use, then retain form state and the existing close animation.
// The boundary is local: loading a modal must not hide the page behind it.
export default function DeferredMount({ active, children }) {
  const [hasOpened, setHasOpened] = useState(active);

  useEffect(() => {
    if (active) setHasOpened(true);
  }, [active]);

  if (!active && !hasOpened) return null;
  return <Suspense fallback={null}>{children}</Suspense>;
}
